module.exports = __webpack_public_path__ + "img/Mixpac_Label_Industry.fa6ad92e.png";